import axiosClient from "./axiosClient";

export async function getSupportConversations() {
  const response = await axiosClient.get("/conversations/support");
  return response.data;
}

export async function getMessages(conversationId, page = 1, pageSize = 30) {
  const response = await axiosClient.get(`/conversations/${conversationId}/messages`, {
    params: { page, pageSize },
  });
  return response.data;
}

export async function sendMessage(conversationId, { messageText }) {
  const response = await axiosClient.post(`/conversations/${conversationId}/messages`, { messageText });
  return response.data;
}

export async function uploadAttachment(conversationId, file, messageText) {
  const formData = new FormData();
  formData.append("file", file);
  if (messageText) formData.append("messageText", messageText);

  const response = await axiosClient.post(`/conversations/${conversationId}/attachments`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function markRead(conversationId) {
  await axiosClient.put(`/conversations/${conversationId}/read`, {});
}
